export default {
  key: 'Ab',
  suffix: 'm7',
  positions: [{
    frets: '464444',
    fingers: '131111',
    barres: 4,
    capo: true
  }, {
    frets: 'x66877',
    fingers: '011423',
    barres: 6,
    capo: true
  }, {
    frets: 'xb9b9x',
    fingers: '021310',
    barres: 9,
    capo: true
  }, {
    frets: 'bbdbcb',
    fingers: '113121',
    barres: 11,
    capo: true
  }]
};